// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__K0vvl","title":"Navbar_title__UwCZ3"};